import { render, staticRenderFns } from "./DataExtractionPanelFooter.vue?vue&type=template&id=8401f6fc&scoped=true&"
import script from "./DataExtractionPanelFooter.vue?vue&type=script&lang=js&"
export * from "./DataExtractionPanelFooter.vue?vue&type=script&lang=js&"
import style0 from "./DataExtractionPanelFooter.vue?vue&type=style&index=0&id=8401f6fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8401f6fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VRow})
